export const createSetupIntent = `
    mutation createSetupIntent($input: CreateSetupIntentInput!) {
        createSetupIntent(input:$input) {
              id
              clientSecret
              created
              customerId
              description
              paymentMethod
              paymentMethodTypes
              status
              usage
        }
}`;

export const updateSetupIntent = `
    mutation updateSetupIntent($input: UpdateSetupIntentInput!) {
        updateSetupIntent(input:$input){
              id
              clientSecret
              customerId
              description
              paymentMethod
              status
              usage
        }
}`;

export const deleteSetupIntent = `
    mutation deleteSetupIntent($input: DeleteSetupIntentInput!) {
        deleteSetupIntent(input:$input)
}`;
